import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt'
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { InfoUserService } from '../info-user/shared/info-user.service';
import { AuthorizeService } from '../shared/authorizeService/authorize.service';
import { GenericResult } from '../globalClass/generic-class.model';
import { LoginService } from '../pages/login/shared/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private jwtHelper: JwtHelperService,
    private _userDataService: InfoUserService,
    private _authorizeService: AuthorizeService,
    private loginService: LoginService,
    private router: Router) { }

  async canActivate(next: ActivatedRouteSnapshot) {
    var stringJwt = sessionStorage.getItem("jwt");
    let token = "";
    let data  = {token:stringJwt};
    await this.loginService.dt(data).then((result:any) => {
      token = result.result;
    });
    if (token) {
      let user = await this._userDataService.getDataUser();

      if (user.modules.includes(next.data.modulo)) {
        return await this.validateRoutes(stringJwt);
      } else {
        this.router.navigate([""]);
        return false;
      }
    } else {
      sessionStorage.removeItem("jwt");
    }
    this.router.navigate(["home-page"]);
    return false;
  }


  async validateRoutes(token: string) {
    let user = await this._userDataService.getDataUser();
    let flag = false;
    let form = {
      token: token,
      idUser: (user != null) ? user.idUser : null
    }
    await this._authorizeService.validateTokenSeguridad(form).then((r: GenericResult) => {
      if (r.error) {
      } else {
        if (r.result) {
          flag = true;
        } else {
          sessionStorage.removeItem('jwt');
          sessionStorage.removeItem("userInfo");
          this._userDataService.remove();
          this.router.navigate(["login"]);
        }
      }
    });
    return flag;
  }
}
